import { render, staticRenderFns } from "./OfertaEdit.vue?vue&type=template&id=ca7b8e36&scoped=true"
import script from "./OfertaEdit.vue?vue&type=script&lang=js"
export * from "./OfertaEdit.vue?vue&type=script&lang=js"
import style0 from "./OfertaEdit.vue?vue&type=style&index=0&id=ca7b8e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7b8e36",
  null
  
)

export default component.exports